export default {
  userPermissions              : state => state.userPermissions,
  academicMainLoadedPermission : state => state.userPermissions[0]?.academicMainId
};
